const previewImg = document.querySelector(".on_hover_img");
const previewText = document.querySelector(".text_on_hover");

const allNavItems = document.querySelectorAll(".menu-drawer__menu-item");

allNavItems.forEach((element) => {

    element.addEventListener("mouseenter", function () {

        const img = this.dataset.image;
        const title = this.dataset.title;

        if (img) {
            previewImg.style.opacity = "0";

            setTimeout(() => {
                previewImg.src = img;
                previewImg.style.opacity = "1";
            }, 150);
        }

        if (title) {
            previewText.textContent = title;
        }

    });

});

// filter background color when active


  document.addEventListener('DOMContentLoaded', function () {

    function updateFacetSummaryClasses() {
      document.querySelectorAll('.facets__disclosure').forEach(function (disclosure) {
        const summary = disclosure.querySelector('.facets__summary');

        if (!summary) return;

        const checkedInputs = disclosure.querySelectorAll(
          'input[type="checkbox"]:checked'
        );

        summary.classList.toggle(
          'has-selected',
          checkedInputs.length > 0
        );
      });
    }

    // Run when page first loads
    updateFacetSummaryClasses();

    // Run immediately when any facet checkbox changes
    document.addEventListener('change', function (event) {
      if (event.target.matches('.facets__disclosure input[type="checkbox"]')) {
        updateFacetSummaryClasses();
      }
    });

    // Shopify replaces filter HTML through AJAX,
    // so run the function again whenever the filter DOM changes
    const facetsContainer =
      document.querySelector('.facets-container') ||
      document.querySelector('.facets__wrapper') ||
      document.body;

    let updateTimer;

    const observer = new MutationObserver(function () {
      clearTimeout(updateTimer);

      updateTimer = setTimeout(function () {
        updateFacetSummaryClasses();
      }, 50);
    });

    observer.observe(facetsContainer, {
      childList: true,
      subtree: true
    });

  });




(function () {
  const ERROR_CLASS = 'ring-size-validation-error';
  const INVALID_CLASS = 'ring-size-invalid';

  function getRingSizeSelect() {
    const labels = document.querySelectorAll('.wcpa_field_label');

    for (const label of labels) {
      const labelText = label.textContent
        .replace('*', '')
        .trim()
        .toLowerCase();

      if (labelText === 'ring size') {
        const wrapper = label.closest('.wcpa_field_wrap');

        if (wrapper) {
          return wrapper.querySelector('select.wcpa_field');
        }
      }
    }

    return null;
  }

  function isRingSizeInvalid(select) {
    if (!select) return false;

    const value = String(select.value || '')
      .trim()
      .toLowerCase();

    return value === '' || value === 'select';
  }

  function removeRingSizeError(select) {
    if (!select) return;

    select.classList.remove(INVALID_CLASS);
    select.removeAttribute('aria-invalid');

    const wrapper = select.closest('.wcpa_field_wrap');

    if (!wrapper) return;

    const error = wrapper.querySelector(`.${ERROR_CLASS}`);

    if (error) {
      error.remove();
    }
  }

  function showRingSizeError(select) {
    if (!select) return;

    removeRingSizeError(select);

    select.classList.add(INVALID_CLASS);
    select.setAttribute('aria-invalid', 'true');

    const wrapper = select.closest('.wcpa_field_wrap');

    if (!wrapper) return;

    const error = document.createElement('div');
    error.className = ERROR_CLASS;
    error.textContent = 'Please select your ring size.';

    wrapper.appendChild(error);

    select.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });

    setTimeout(() => {
      select.focus();
    }, 300);
  }

  function validateRingSize() {
    const ringSizeSelect = getRingSizeSelect();

    /*
     * Products without Ring Size continue normally.
     */
    if (!ringSizeSelect) {
      return true;
    }

    if (isRingSizeInvalid(ringSizeSelect)) {
      showRingSizeError(ringSizeSelect);
      return false;
    }

    removeRingSizeError(ringSizeSelect);
    return true;
  }

  /*
   * Remove error immediately after the customer
   * selects a valid Ring Size.
   */
  document.addEventListener('change', function (event) {
    const ringSizeSelect = getRingSizeSelect();

    if (!ringSizeSelect || event.target !== ringSizeSelect) {
      return;
    }

    if (!isRingSizeInvalid(ringSizeSelect)) {
      removeRingSizeError(ringSizeSelect);
    }
  });

  /*
   * Block normal Shopify form submission.
   */
  document.addEventListener(
    'submit',
    function (event) {
      const form = event.target;

      if (
        !form.matches(
          'form[data-type="add-to-cart-form"], form[action*="/cart/add"]'
        )
      ) {
        return;
      }

      if (!validateRingSize()) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
      }
    },
    true
  );

  /*
   * Extra protection because some themes/apps
   * handle Add to Cart through JavaScript clicks.
   */
  document.addEventListener(
    'click',
    function (event) {
      const addButton = event.target.closest(
        'button[name="add"], .product-form__submit'
      );

      if (!addButton) return;

      const form = addButton.closest(
        'form[data-type="add-to-cart-form"], form[action*="/cart/add"]'
      );

      if (!form) return;

      if (!validateRingSize()) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
      }
    },
    true
  );
})();

// for default from variant 


(function () {
  const SIZE_SELECTOR =
    'select[name="options[Choose your Size]"]';

  const ERROR_CLASS = 'choose-size-error';
  const INVALID_CLASS = 'choose-size-invalid';

  function getSizeSelect() {
    return document.querySelector(SIZE_SELECTOR);
  }

  function isSizeInvalid(select) {
    if (!select) return false;

    const value = String(select.value || '')
      .trim()
      .toLowerCase();

    return (
      value === '' ||
      value === 'select' ||
      value === 'choose your size'
    );
  }

  function getSizeFieldWrapper(select) {
    if (!select) return null;

    return (
      select.closest('.product-form__input') ||
      select.closest('fieldset') ||
      select.parentElement
    );
  }

  function removeSizeError(select) {
    if (!select) return;

    select.classList.remove(INVALID_CLASS);
    select.removeAttribute('aria-invalid');

    const wrapper = getSizeFieldWrapper(select);

    if (!wrapper) return;

    const error = wrapper.querySelector(
      '.' + ERROR_CLASS
    );

    if (error) {
      error.remove();
    }
  }

  function showSizeError(select) {
    if (!select) return;

    removeSizeError(select);

    select.classList.add(INVALID_CLASS);
    select.setAttribute('aria-invalid', 'true');

    const wrapper = getSizeFieldWrapper(select);

    if (wrapper) {
      const error = document.createElement('p');

      error.className = ERROR_CLASS;
      error.textContent =
        'Please choose your size before continuing.';

      wrapper.appendChild(error);
    }

    select.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });

    setTimeout(function () {
      select.focus();
    }, 300);
  }

  function validateSize() {
    const select = getSizeSelect();

    /*
     * Products without the "Choose your Size"
     * option should continue normally.
     */
    if (!select) {
      return true;
    }

    if (isSizeInvalid(select)) {
      showSizeError(select);
      return false;
    }

    removeSizeError(select);
    return true;
  }

  /*
   * Remove the error immediately after
   * the customer selects a valid size.
   */
  document.addEventListener(
    'change',
    function (event) {
      if (!event.target.matches(SIZE_SELECTOR)) {
        return;
      }

      if (isSizeInvalid(event.target)) {
        showSizeError(event.target);
      } else {
        removeSizeError(event.target);
      }
    }
  );

  /*
   * Block normal Add to Cart click.
   */
  document.addEventListener(
    'click',
    function (event) {
      const addButton = event.target.closest(
        'button[name="add"], .product-form__submit'
      );

      if (!addButton) return;

      const productForm = addButton.closest(
        'form[data-type="add-to-cart-form"], form[action*="/cart/add"]'
      );

      if (!productForm) return;

      if (!validateSize()) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
      }
    },
    true
  );

  /*
   * Block normal product form submission.
   */
  document.addEventListener(
    'submit',
    function (event) {
      const form = event.target;

      if (
        !form.matches(
          'form[data-type="add-to-cart-form"], form[action*="/cart/add"]'
        )
      ) {
        return;
      }

      if (!validateSize()) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
      }
    },
    true
  );

  /*
   * Block Shopify Buy It Now / dynamic checkout.
   * composedPath() detects clicks inside
   * Shopify's custom element or shadow DOM.
   */
  document.addEventListener(
    'click',
    function (event) {
      const path = event.composedPath
        ? event.composedPath()
        : [];

      const dynamicCheckoutClicked = path.some(
        function (element) {
          if (!element || !element.matches) {
            return false;
          }

          return element.matches(
            'shopify-buy-it-now-button,' +
            '.shopify-payment-button,' +
            '.shopify-payment-button__button,' +
            '[data-testid="Checkout-button"]'
          );
        }
      );

      if (!dynamicCheckoutClicked) {
        return;
      }

      if (!validateSize()) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
      }
    },
    true
  );

  /*
   * Extra protection for keyboard activation
   * of the Buy It Now button.
   */
  document.addEventListener(
    'keydown',
    function (event) {
      if (
        event.key !== 'Enter' &&
        event.key !== ' '
      ) {
        return;
      }

      const path = event.composedPath
        ? event.composedPath()
        : [];

      const checkoutButtonFocused = path.some(
        function (element) {
          if (!element || !element.matches) {
            return false;
          }

          return element.matches(
            'shopify-buy-it-now-button,' +
            '.shopify-payment-button__button'
          );
        }
      );

      if (
        checkoutButtonFocused &&
        !validateSize()
      ) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
      }
    },
    true
  );
})();

// default variant choose end here

// for preditive search
document.addEventListener('DOMContentLoaded', function () {
  const searchDetails = document.querySelector(
    'details-modal.header__search > details'
  );

  const headerWrapper = document.querySelector('.header-wrapper');

  if (!searchDetails || !headerWrapper) {
    console.log('Search details or header wrapper not found');
    return;
  }

  function updateSearchClass() {
    headerWrapper.classList.toggle(
      'ctm-preditive-open',
      searchDetails.hasAttribute('open')
    );
  }

  // Run once on page load
  updateSearchClass();

  // Detect opening and closing of search details
  searchDetails.addEventListener('toggle', updateSearchClass);

  // Backup observer for Shopify theme scripts
  const observer = new MutationObserver(updateSearchClass);

  observer.observe(searchDetails, {
    attributes: true,
    attributeFilter: ['open']
  });
});

// for search icon

document.addEventListener('DOMContentLoaded', function () {
  const mobileSearch = document.querySelector('.search_mobile_only');
  const searchDetails = document.querySelector(
    'details-modal.header__search > details'
  );
  const searchSummary = searchDetails?.querySelector('summary');
  const searchInput = document.querySelector('#Search-In-Modal');

  if (!mobileSearch || !searchDetails) return;

  mobileSearch.addEventListener('click', function () {
    searchDetails.setAttribute('open', '');

    if (searchSummary) {
      searchSummary.setAttribute('aria-expanded', 'true');
    }

    setTimeout(function () {
      searchInput?.focus();
    }, 100);
  });
});


// =====================================================
// CART + LIFETIME WARRANTY + FREE GIFT
// FAST OPTIMIZED VERSION
// =====================================================

const WARRANTY_VARIANT_ID = 54402633335094;
const FREE_GIFT_VARIANT_ID = 54374583173430;
const FREE_GIFT_PRODUCT_ID = 10800608018742;

const FREE_GIFT_THRESHOLD = 150000; // $1,500
const FREE_SHIPPING_THRESHOLD = 30000; // $300
// const freegift_text=document.querySelector(".offer_applied_text_container");


const CART_SECTIONS = [
  "cart-drawer",
  "cart-icon-bubble"
];

let freeGiftCelebrated = false;

let warrantySyncRunning = false;
let warrantyActionRunning = false;
let freeGiftActionRunning = false;
let discountActionRunning = false;
let cartSyncRunning = false;

let currentCartSnapshot = null;

const FREE_GIFT_REMOVED_STORAGE_KEY = "freeGiftManuallyRemoved";
const MANUAL_DISCOUNT_STORAGE_KEY = "manualDiscountCode";

let freeGiftManuallyRemoved = false;
let manualDiscountCode = "";

try {

  freeGiftManuallyRemoved =
    window.sessionStorage.getItem(
      FREE_GIFT_REMOVED_STORAGE_KEY
    ) === "true";

  manualDiscountCode =
    window.sessionStorage.getItem(
      MANUAL_DISCOUNT_STORAGE_KEY
    ) || "";

}
catch (error) {

  console.warn(
    "Cart session storage is unavailable:",
    error
  );

}


function setFreeGiftManuallyRemoved(value) {

  freeGiftManuallyRemoved =
    Boolean(value);

  try {

    if (freeGiftManuallyRemoved) {

      window.sessionStorage.setItem(
        FREE_GIFT_REMOVED_STORAGE_KEY,
        "true"
      );

    }
    else {

      window.sessionStorage.removeItem(
        FREE_GIFT_REMOVED_STORAGE_KEY
      );

    }

  }
  catch (error) {

    console.warn(
      "Could not persist free gift preference:",
      error
    );

  }

}


function setManualDiscountCode(value) {

  manualDiscountCode =
    String(value || "").trim();

  try {

    if (manualDiscountCode) {

      window.sessionStorage.setItem(
        MANUAL_DISCOUNT_STORAGE_KEY,
        manualDiscountCode
      );

    }
    else {

      window.sessionStorage.removeItem(
        MANUAL_DISCOUNT_STORAGE_KEY
      );

    }

  }
  catch (error) {

    console.warn(
      "Could not persist manual discount code:",
      error
    );

  }

}
let offerTextLocked = false;
let lockedOfferTextValue = "";

let cartUpdateTimer = null;


// =====================================================
// GET CART
// =====================================================

async function getCart() {

  const response =
    await fetch(
      "/cart.js",
      {
        headers: {
          Accept: "application/json"
        }
      }
    );


  if (!response.ok) {

    throw new Error(
      "Could not fetch cart"
    );

  }


  const cart =
    await response.json();


  currentCartSnapshot =
    cart;


  return cart;

}


// =====================================================
// ITEM HELPERS
// =====================================================

function isWarrantyItem(item) {

  if (!item) {
    return false;
  }


  return (

    Number(item.variant_id) ===
      Number(WARRANTY_VARIANT_ID)

    ||

    Number(item.id) ===
      Number(WARRANTY_VARIANT_ID)

    ||

    item.properties?.["_Lifetime Warranty"] ===
      "Yes"

    ||

    Boolean(
      item.properties?.["_Warranty Parent Key"]
    )

  );

}

function isFreeGiftItem(item) {

  return (

    Number(item.variant_id) ===
      Number(FREE_GIFT_VARIANT_ID)

    ||

    Number(item.product_id) ===
      Number(FREE_GIFT_PRODUCT_ID)

  );

}


// =====================================================
// GET WARRANTY PARENT
// =====================================================

function getWarrantyParentKey(item) {

  return (

    item.parent_relationship
      ?.parent_key

    ||

    item.properties
      ?.["_Warranty Parent Key"]

    ||

    null

  );

}


// =====================================================
// FIND WARRANTY FOR PRODUCT
// =====================================================

function findWarrantyForParent(
  cart,
  parentLineKey
) {

  return cart.items.find(

    item =>

      isWarrantyItem(item)

      &&

      getWarrantyParentKey(item) ===
        parentLineKey

  );

}


// =====================================================
// FREE GIFT ELIGIBLE SUBTOTAL
//
// EXCLUDES:
// FREE GIFT
// LIFETIME WARRANTY
// =====================================================

// =====================================================
// MAIN PRODUCT TOTAL ONLY
//
// EXCLUDES:
// 1. Lifetime Warranty
// 2. Free Gift
// 3. Any nested child/add-on product
// =====================================================

function getFreeGiftEligibleSubtotal(cart) {

  if (
    !cart ||
    !Array.isArray(cart.items)
  ) {
    return 0;
  }


  return cart.items.reduce(
    (total, item) => {


      // -----------------------------------------
      // EXCLUDE FREE GIFT
      // -----------------------------------------

      if (
        isFreeGiftItem(item)
      ) {
        return total;
      }


      // -----------------------------------------
      // EXCLUDE LIFETIME WARRANTY
      // -----------------------------------------

      if (
        isWarrantyItem(item)
      ) {
        return total;
      }


      // -----------------------------------------
      // EXCLUDE ANY NESTED CHILD PRODUCT
      // -----------------------------------------

      if (
        item.parent_relationship?.parent_key
      ) {
        return total;
      }


      // -----------------------------------------
      // MAIN PRODUCT ONLY
      // -----------------------------------------

      return (
        total +
        Number(
          item.final_line_price

          ??

          item.line_price

          ??

          0
        )
      );


    },
    0
  );

}

function applyLockedOfferText() {

  if (!offerTextLocked) {
    return;
  }

  const offerText =
    document.querySelector(
      ".offer_applied_text_container"
    );

  if (offerText) {

    offerText.textContent =
      lockedOfferTextValue;

  }

}function applyLockedOfferText() {

  if (!offerTextLocked) {
    return;
  }

  const offerText =
    document.querySelector(
      ".offer_applied_text_container"
    );

  if (offerText) {

    offerText.textContent =
      lockedOfferTextValue;

  }

}


// =====================================================
// RENDER CART
// NO PAGE REFRESH
// =====================================================

function renderCartSections(data) {

  if (
    !data ||
    !data.sections
  ) {

    return;

  }


  const cartDrawer =
    document.querySelector(
      "cart-drawer"
    );


  if (
  cartDrawer &&
  typeof cartDrawer.renderContents ===
    "function"
) {

  cartDrawer.renderContents(
    data
  );

  // Immediately restore locked offer text
  // before browser paints the new cart
  applyLockedOfferText();

  return;
}


  Object.entries(
    data.sections
  ).forEach(
    ([sectionId, html]) => {


      if (!html) {

        return;

      }


      const currentSection =
        document.getElementById(
          `shopify-section-${sectionId}`
        );


      if (!currentSection) {

        return;

      }


      const parsed =
        new DOMParser()
          .parseFromString(
            html,
            "text/html"
          );


      const replacement =
        parsed.getElementById(
          `shopify-section-${sectionId}`
        );


      if (replacement) {

        currentSection.replaceWith(
          replacement
        );

      } else {

        currentSection.innerHTML =
          html;

      }


    }
  );
  applyLockedOfferText();

}


// =====================================================
// CHANGE CART LINE
// =====================================================

async function changeCartLine(
  lineKey,
  quantity,
  render = true
) {

  const response =
    await fetch(
      "/cart/change.js",
      {

        method: "POST",

        headers: {

          "Content-Type":
            "application/json",

          Accept:
            "application/json"

        },


        body: JSON.stringify({

          id:
            lineKey,

          quantity:
            quantity,

          sections:
            CART_SECTIONS,

          sections_url:
            window.location.pathname

        })

      }
    );


  const data =
    await response.json();


  if (!response.ok) {

    throw new Error(

      data.description ||

      data.message ||

      "Cart line could not be updated"

    );

  }


  if (render) {

    renderCartSections(
      data
    );

  }


  return data;

}


// =====================================================
// CONFETTI
// =====================================================

function showCelebration() {

  const drawer =
    document.querySelector(
      ".cart-drawer"
    );


  if (!drawer) {

    return;

  }


  if (
    drawer.querySelector(
      ".drawer-confetti"
    )
  ) {

    return;

  }


  const container =
    document.createElement(
      "div"
    );


  container.className =
    "drawer-confetti";


  drawer.appendChild(
    container
  );


  for (
    let i = 0;
    i < 60;
    i++
  ) {

    const piece =
      document.createElement(
        "span"
      );


    piece.className =
      "confetti-piece";


    piece.style.left =
      `${Math.random() * 100}%`;


    piece.style.animationDuration =
      `${2 + Math.random() * 2}s`;


    piece.style.animationDelay =
      `${Math.random() * 0.5}s`;


    piece.style.setProperty(

      "--drift",

      `${-80 +
        Math.random() * 160}px`

    );


    piece.style.setProperty(

      "--rotate",

      `${360 +
        Math.random() * 720}deg`

    );


    piece.addEventListener(
      "animationend",
      () => piece.remove()
    );


    container.appendChild(
      piece
    );

  }


  setTimeout(
    () => container.remove(),
    5000
  );

}

function getActiveManualCouponCode(cart) {

  const verifiedCoupon =
    getVerifiedBackendCoupon(
      cart
    );


  return verifiedCoupon
    ? verifiedCoupon.code
    : "";

}


function updateOfferText(
  eligibleTotal,
  cart = null
) {

  const offerText =
    document.querySelector(
      ".offer_applied_text_container"
    );

  if (!offerText) {
    return;
  }


  if (offerTextLocked) {

    offerText.textContent =
      lockedOfferTextValue;

    return;

  }


  // =========================================
  // MANUAL COUPON HAS HIGHEST PRIORITY
  // =========================================

  const activeCoupon =
    getActiveManualCouponCode(
      cart
    );


  if (activeCoupon) {

    offerText.textContent =
      `${activeCoupon} Applied`;

    return;

  }


  // =========================================
  // FREE GIFT STATUS
  // =========================================

  const freeGiftInCart =
    Boolean(

      cart &&

      Array.isArray(cart.items) &&

      cart.items.some(
        isFreeGiftItem
      )

    );


  // =========================================
  // $1500+
  // =========================================

  if (
    eligibleTotal >=
    FREE_GIFT_THRESHOLD
  ) {

    if (freeGiftInCart) {

      offerText.textContent =
        "Free Gift Applied";

    }

    else if (
      freeGiftManuallyRemoved
    ) {

      offerText.textContent =
        "Free Gift Removed · Free Shipping Applied";

    }

    else {

      offerText.textContent =
        "Free Gift Available";

    }


    return;

  }


  // =========================================
  // $300 - $1499.99
  // =========================================

  if (
    eligibleTotal >=
    FREE_SHIPPING_THRESHOLD
  ) {

    const remaining =
      FREE_GIFT_THRESHOLD -
      eligibleTotal;


    const formattedRemaining =
      new Intl.NumberFormat(
        "en-US",
        {
          style: "currency",
          currency: "USD",
          maximumFractionDigits: 2
        }
      ).format(
        remaining / 100
      );


    offerText.textContent =
      `Free Shipping Applied · Shop ${formattedRemaining} more for a free gift`;

    return;

  }


  // =========================================
  // BELOW $300
  // =========================================

  const remainingShipping =
    FREE_SHIPPING_THRESHOLD -
    eligibleTotal;


  const formattedRemainingShipping =
    new Intl.NumberFormat(
      "en-US",
      {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: 2
      }
    ).format(

      Math.max(
        0,
        remainingShipping
      ) / 100

    );


  offerText.textContent =
    `Shop ${formattedRemainingShipping} more for free shipping`;

}

// =====================================================
// FREE GIFT + MANUAL DISCOUNT UI
// =====================================================

function showDiscountOnlyOnFirstItem() {

  const cartItems =
    document.querySelectorAll(
      "#CartDrawer-CartItems .cart-item"
    );

  cartItems.forEach(
    (cartItem, index) => {

      const discounts =
        cartItem.querySelectorAll(
          ".discounts__discount"
        );

      discounts.forEach(
        discount => {

          discount.style.display =
            index === 0
              ? "block"
              : "none";

        }
      );

    }
  );

}


function getAppliedManualDiscountCodes(cart) {

  const codes =
    new Set();


  if (!cart) {
    return [];
  }


  // =========================================
  // SHOPIFY discount_codes
  // =========================================

  if (
    Array.isArray(
      cart.discount_codes
    )
  ) {

    cart.discount_codes.forEach(
      discount => {

        if (!discount) {
          return;
        }


        const code =

          typeof discount === "string"

            ?

            discount

            :

            (
              discount.code ||
              discount.title ||
              ""
            );


        if (code) {

          codes.add(
            String(code).trim()
          );

        }

      }
    );

  }


  // =========================================
  // DISCOUNT APPLICATION HELPER
  // =========================================

  const collectApplication =
    application => {

      if (!application) {
        return;
      }


      const type =
        String(
          application.type || ""
        )
          .trim()
          .toLowerCase();


      if (
        type !== "discount_code" &&
        type !== "code"
      ) {
        return;
      }


      const code =

        application.code ||

        application.title ||

        "";


      if (code) {

        codes.add(
          String(code).trim()
        );

      }

    };


  // =========================================
  // CART LEVEL DISCOUNTS
  // =========================================

  if (
    Array.isArray(
      cart.cart_level_discount_applications
    )
  ) {

    cart
      .cart_level_discount_applications
      .forEach(
        collectApplication
      );

  }


  // =========================================
  // LINE LEVEL DISCOUNTS
  // =========================================

  if (
    Array.isArray(
      cart.items
    )
  ) {

    cart.items.forEach(
      item => {

        const allocations =
          Array.isArray(
            item.line_level_discount_allocations
          )

            ?

            item.line_level_discount_allocations

            :

            [];


        allocations.forEach(
          allocation => {

            collectApplication(
              allocation.discount_application
            );

          }
        );


        // Additional fallback
        if (
          Array.isArray(
            item.discounts
          )
        ) {

          item.discounts.forEach(
            discount => {

              if (
                discount &&
                discount.title
              ) {

                codes.add(
                  String(
                    discount.title
                  ).trim()
                );

              }

            }
          );

        }

      }
    );

  }


  return Array.from(
    codes
  );

}

// =====================================================
// GET REAL BACKEND DISCOUNT AMOUNT FOR A CODE
//
// IMPORTANT:
// - Only discounts confirmed by Shopify count
// - FREE GIFT line is ignored
// - Lifetime warranty can still receive normal coupon
// =====================================================

function getBackendDiscountAmountForCode(
  cart,
  code
) {

  if (
    !cart ||
    !Array.isArray(cart.items)
  ) {
    return 0;
  }


  const normalizedCode =
    String(code || "")
      .trim()
      .toUpperCase();


  if (
    !normalizedCode ||
    normalizedCode === "FREEGIFT"
  ) {
    return 0;
  }


  let total = 0;


  // =========================================
  // LINE LEVEL DISCOUNTS
  // =========================================

  cart.items.forEach(item => {

    // Ignore free gift discount completely
    if (isFreeGiftItem(item)) {
      return;
    }


    const allocations =
      Array.isArray(
        item.line_level_discount_allocations
      )
        ? item.line_level_discount_allocations
        : [];


    allocations.forEach(allocation => {

      const application =
        allocation?.discount_application;


      if (!application) {
        return;
      }


      const appliedCode =
        String(
          application.code ||
          application.title ||
          ""
        )
          .trim()
          .toUpperCase();


      if (
        appliedCode === normalizedCode
      ) {

        total +=
          Number(
            allocation.amount || 0
          );

      }

    });

  });


  // =========================================
  // CART LEVEL DISCOUNT
  // =========================================

  if (
    Array.isArray(
      cart.cart_level_discount_applications
    )
  ) {

    cart.cart_level_discount_applications
      .forEach(application => {

        const appliedCode =
          String(
            application?.code ||
            application?.title ||
            ""
          )
            .trim()
            .toUpperCase();


        if (
          appliedCode === normalizedCode
        ) {

          total +=
            Number(
              application.total_allocated_amount ||
              application.amount ||
              0
            );

        }

      });

  }


  return total;
}


// =====================================================
// REAL BACKEND COUPON
// =====================================================

function getVerifiedBackendCoupon(cart) {

  if (!cart) {
    return null;
  }


  const codes =
    getAppliedManualDiscountCodes(
      cart
    );


  for (const code of codes) {

    const normalized =
      String(code || "")
        .trim()
        .toUpperCase();


    if (
      !normalized ||
      normalized === "FREEGIFT"
    ) {
      continue;
    }


    const amount =
      getBackendDiscountAmountForCode(
        cart,
        code
      );


    // Only accept coupon when Shopify
    // actually gives a discount
    if (amount > 0) {

      return {
        code:
          String(code).trim(),

        amount:
          amount
      };

    }

  }


  return null;
}

function isDiscountCodeApplied(
  cart,
  code
) {

  const normalizedCode =
    String(code || "")
      .trim()
      .toLowerCase();


  if (!normalizedCode) {
    return false;
  }


  return getAppliedManualDiscountCodes(
    cart
  ).some(
    appliedCode =>

      String(appliedCode)
        .trim()
        .toLowerCase()

      ===

      normalizedCode

  );

}



function escapeDiscountText(value) {

  return String(value || "")

    .replace(
      /&/g,
      "&amp;"
    )

    .replace(
      /</g,
      "&lt;"
    )

    .replace(
      />/g,
      "&gt;"
    )

    .replace(
      /"/g,
      "&quot;"
    )

    .replace(
      /'/g,
      "&#039;"
    );

}



function setDiscountMessage(
  message,
  type = ""
) {

  const discountForm =
    document.querySelector(
      ".custom-discount-form"
    );


  if (!discountForm) {
    return;
  }


  let messageElement =
    document.querySelector(
      "[data-manual-discount-message]"
    );


  if (!messageElement) {

    messageElement =
      document.createElement(
        "div"
      );


    messageElement.setAttribute(
      "data-manual-discount-message",
      ""
    );


    messageElement.className =
      "custom-manual-discount-message";


    discountForm.insertAdjacentElement(
      "afterend",
      messageElement
    );

  }


  messageElement.textContent =
    message || "";


  messageElement.dataset.type =
    type || "";


  messageElement.hidden =
    !message;

}
// =====================================================
// CART LINE DISCOUNT DISPLAY
// FREE GIFT = FREE GIFT LABEL
// NORMAL PRODUCTS = KEEP SHOPIFY DISCOUNTS VISIBLE
// =====================================================

function updateFreeGiftLineDiscounts(cart) {

  if (
    !cart ||
    !Array.isArray(cart.items)
  ) {
    return;
  }


  const cartItems =
    document.querySelectorAll(
      "#CartDrawer-CartItems .cart-item"
    );


  cartItems.forEach(
    (cartItemElement, index) => {

      const item =
        cart.items[index];


      if (!item) {
        return;
      }


      const discountLists =
        cartItemElement.querySelectorAll(
          ".discounts"
        );


      const isActualFreeGift =
        isFreeGiftItem(item) &&
        item.properties?.["_Free Gift"] === "Yes";


      discountLists.forEach(
        discountList => {

          // =========================================
          // FREE GIFT
          // =========================================

          if (isActualFreeGift) {

            discountList.style.display = "";


            discountList
              .querySelectorAll(
                ".discounts__discount"
              )
              .forEach(
                discount => {

                  const originalSvg =
                    discount.querySelector(
                      "svg"
                    );


                  const svg =
                    originalSvg
                      ? originalSvg.cloneNode(true)
                      : null;


                  discount.innerHTML = "";


                  if (svg) {

                    discount.appendChild(
                      svg
                    );

                  }


                  discount.append(
                    document.createTextNode(
                      " FREE GIFT"
                    )
                  );

                }
              );


            return;

          }


          // =========================================
          // NORMAL PRODUCT
          // IMPORTANT:
          // DON'T HIDE MANUAL DISCOUNTS
          // =========================================

          discountList.style.display = "";

        }
      );

    }
  );

}

function clearFreeGiftCouponUI() {

  // =========================================
  // CLEAR INPUT ONLY IF IT CONTAINS FREEGIFT
  // =========================================

  const discountInput =
    document.querySelector(
      "#DiscountCode"
    );

  if (
    discountInput &&
    String(discountInput.value || "")
      .trim()
      .toUpperCase() === "FREEGIFT"
  ) {

    discountInput.value = "";

  }


  // =========================================
  // CLEAR SAVED FREEGIFT STATE
  // =========================================

  if (
    String(manualDiscountCode || "")
      .trim()
      .toUpperCase() === "FREEGIFT"
  ) {

    setManualDiscountCode("");

  }


  // =========================================
  // REMOVE FREEGIFT COUPON DISPLAY
  // =========================================

  const appliedDiscount =
    document.querySelector(
      "[data-applied-manual-discount]"
    );

  if (appliedDiscount) {

    const codeText =
      appliedDiscount
        .querySelector("span")
        ?.textContent
        ?.trim()
        ?.toUpperCase() || "";


    if (codeText === "FREEGIFT") {

      appliedDiscount.remove();

    }

  }


  // =========================================
  // REMOVE FREE GIFT TEXT
  // =========================================

  const freeGiftCodeText =
    document.querySelector(
      "[data-freegift-code-text]"
    );

  if (freeGiftCodeText) {

    freeGiftCodeText.remove();

  }

}


function updateFreeGiftDiscountUI(
  cart
) {

  if (!cart) {
    return;
  }


  currentCartSnapshot =
    cart;


  updateFreeGiftLineDiscounts(
    cart
  );
  showDiscountOnlyOnFirstItem();


  const discountAmountElement =
    document.querySelector(
      "#DiscountAmount"
    );


  const discountInput =
    document.querySelector(
      "#DiscountCode"
    );


  const discountButton =
    document.querySelector(
      "#ApplyDiscount"
    );


  const discountForm =
    document.querySelector(
      ".custom-discount-form"
    );


  const eligibleTotal =
    getFreeGiftEligibleSubtotal(
      cart
    );


  const freeGiftItem =
    Array.isArray(
      cart.items
    )

      ?

      cart.items.find(
        isFreeGiftItem
      )

      :

      null;


  const freeGiftApplied =
    Boolean(

      freeGiftItem &&

      eligibleTotal >=
      FREE_GIFT_THRESHOLD

    );
    if (!freeGiftApplied) {

  clearFreeGiftCouponUI();

}


  // =================================================
  // MANUAL DISCOUNT INPUT ALWAYS ENABLED
  // =================================================

  if (discountInput) {

    discountInput.disabled =
      discountActionRunning;


    if (discountActionRunning) {

      discountInput.setAttribute(
        "aria-disabled",
        "true"
      );

    }

    else {

      discountInput.removeAttribute(
        "aria-disabled"
      );

    }


   const activeCoupon =
  getActiveManualCouponCode(
    cart
  );

if (activeCoupon) {

  discountInput.value = "";

}

  }


  // =================================================
  // APPLY BUTTON
  // =================================================

  if (discountButton) {

    discountButton.disabled =
      discountActionRunning;


    discountButton.textContent =
      discountActionRunning

        ?

        "Applying..."

        :

        "Apply Now";

  }


  const verifiedCoupon =
  getVerifiedBackendCoupon(cart);

let totalDiscount = 0;


// ================================================
// 1. MANUAL COUPON HAS HIGHEST PRIORITY
// ================================================

if (verifiedCoupon) {

  totalDiscount =
    Number(verifiedCoupon.amount || 0);

}


// ================================================
// 2. NO COUPON + $1500+ + FREE GIFT PRESENT
// ================================================

else if (
  eligibleTotal >= FREE_GIFT_THRESHOLD &&
  freeGiftApplied &&
  freeGiftItem
) {

  const freeGiftElement =
    document.querySelector(
      `[data-product-id="${FREE_GIFT_PRODUCT_ID}"]`
    );

  const comparePrice =
    Number(
      freeGiftElement?.dataset.comparePrice || 0
    );

  totalDiscount =
    comparePrice ||
    Number(freeGiftItem.original_price || 0);

}


// ================================================
// 3. EVERYTHING ELSE
// ================================================

else {

  totalDiscount = 0;

}


// ================================================
// FORMAT DISCOUNT
// ================================================

const formattedDiscount =
  new Intl.NumberFormat(
    "en-US",
    {
      style: "currency",
      currency: cart.currency || "USD",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }
  ).format(
    totalDiscount / 100
  );


if (discountAmountElement) {

  discountAmountElement.textContent =
    totalDiscount > 0
      ? `-${formattedDiscount}`
      : "$0.00";

}


  // =================================================
  // FREE GIFT LABEL
  // =================================================

  if (discountForm) {

    let freeGiftCodeText =
      document.querySelector(
        "[data-freegift-code-text]"
      );


    if (freeGiftApplied) {

      if (!freeGiftCodeText) {

        freeGiftCodeText =
          document.createElement(
            "div"
          );


        freeGiftCodeText.setAttribute(
          "data-freegift-code-text",
          ""
        );


        freeGiftCodeText.className =
          "custom-freegift-code";


        discountForm.insertAdjacentElement(
          "afterend",
          freeGiftCodeText
        );

      }


      freeGiftCodeText.innerHTML = `
        <svg
          aria-hidden="true"
          focusable="false"
          role="presentation"
          viewBox="0 0 12 12"
          width="14"
          height="14"
          style="margin-right:5px;"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7 0h3a2 2 0 0 1 2 2v3a1 1 0 0 1-.3.7l-6 6a1 1 0 0 1-1.4 0l-4-4a1 1 0 0 1 0-1.4l6-6A1 1 0 0 1 7 0zm2 2a1 1 0 1 0 2 0 1 1 0 0 0-2 0z"
            fill="currentColor"
          ></path>
        </svg>

        FREE GIFT
      `;

    }

    else if (
      freeGiftCodeText
    ) {

      freeGiftCodeText.remove();

    }

  }


  // =================================================
  // APPLIED MANUAL DISCOUNT
  // =================================================

  let appliedDiscountElement =
    document.querySelector(
      "[data-applied-manual-discount]"
    );


  let appliedCodes =
  getAppliedManualDiscountCodes(
    cart
  );


// If free gift product is gone,
// don't treat FREEGIFT as a manual discount anymore
if (!freeGiftApplied) {

  appliedCodes =
    appliedCodes.filter(
      code =>

        String(code || "")
          .trim()
          .toUpperCase()

        !==

        "FREEGIFT"
    );

}

if (verifiedCoupon) {

  if (
    manualDiscountCode !==
    verifiedCoupon.code
  ) {

    setManualDiscountCode(
      verifiedCoupon.code
    );

  }

}
else {

  // Shopify says no real coupon exists
  setManualDiscountCode(
    ""
  );

}

if (verifiedCoupon) {

    if (!appliedDiscountElement) {

      appliedDiscountElement =
        document.createElement(
          "div"
        );


      appliedDiscountElement.setAttribute(
        "data-applied-manual-discount",
        ""
      );


      appliedDiscountElement.className =
        "custom-applied-discount";


      if (discountForm) {

        discountForm.insertAdjacentElement(
          "afterend",
          appliedDiscountElement
        );

      }

    }


    if (appliedDiscountElement) {

      appliedDiscountElement.innerHTML = `

        <span>
       ${escapeDiscountText(
  verifiedCoupon.code
)}
        </span>

        <button
          type="button"
          data-remove-manual-discount
         aria-label="Remove discount ${escapeDiscountText(
  verifiedCoupon.code
          )}"
        >
          ×
        </button>

      `;

    }

  }

  else if (
    appliedDiscountElement
  ) {

    appliedDiscountElement.remove();

  }

}



// =====================================================
// APPLY / REMOVE SHOPIFY DISCOUNT
// =====================================================

// =====================================================
// APPLY / REMOVE SHOPIFY MANUAL DISCOUNT
// =====================================================

async function updateManualDiscount(code) {

  if (discountActionRunning) {
    return false;
  }


  const normalizedCode =
    String(code || "").trim();


  discountActionRunning = true;


  const discountInput =
    document.querySelector(
      "#DiscountCode"
    );


  const discountButton =
    document.querySelector(
      "#ApplyDiscount"
    );


  // =========================================
  // LOADING STATE
  // =========================================

  if (discountInput) {

    discountInput.disabled =
      true;

  }


  if (discountButton) {

    discountButton.disabled =
      true;


    discountButton.textContent =
      normalizedCode

        ?

        "Applying..."

        :

        "Removing...";

  }


  try {

    const root =
      window.Shopify?.routes?.root || "/";


    // =========================================
    // SHOPIFY CART UPDATE
    // =========================================

    const response =
      await fetch(

        root + "cart/update.js",

        {

          method: "POST",


          headers: {

            "Content-Type":
              "application/json",

            Accept:
              "application/json"

          },


          body: JSON.stringify({

            discount:
              normalizedCode,

            sections:
              CART_SECTIONS,

            sections_url:
              window.location.pathname

          })

        }

      );


    const responseData =
      await response.json();


    console.log(
      "Discount update response:",
      responseData
    );


    if (!response.ok) {

      throw new Error(

        responseData.description ||

        responseData.message ||

        "Discount could not be updated"

      );

    }


    // =========================================
    // RENDER SHOPIFY SECTIONS FIRST
    // =========================================

    if (
      responseData.sections
    ) {

      renderCartSections(
        responseData
      );

    }


    // =========================================
    // IMPORTANT
    // GET FRESH CART AFTER DISCOUNT NEGOTIATION
    // =========================================

    let latestCart =
  await getCart();


    currentCartSnapshot =
      latestCart;


    console.log(
      "Cart after discount:",
      latestCart
    );


    // =========================================
    // REMOVING DISCOUNT
    // =========================================

    if (!normalizedCode) {

      setManualDiscountCode(
        ""
      );
      // Coupon removed.
// Re-evaluate whether free gift should return.
await manageFreeGift(
  latestCart
);

latestCart =
  await getCart();


      setDiscountMessage(
        "Discount code removed.",
        "success"
      );


      // Clear new input after drawer render
      const newInput =
        document.querySelector(
          "#DiscountCode"
        );


      if (newInput) {

        newInput.value =
          "";

      }

    }


    // =========================================
    // APPLYING DISCOUNT
    // =========================================

    else {

    const backendCoupon =
  getVerifiedBackendCoupon(
    latestCart
  );


const applied =
  Boolean(

    backendCoupon &&

    String(
      backendCoupon.code
    )
      .trim()
      .toUpperCase()

    ===

    normalizedCode
      .trim()
      .toUpperCase()

  );


      console.log(
        `Discount ${normalizedCode} detected:`,
        applied
      );


      if (!applied) {

        setManualDiscountCode(
          ""
        );


        setDiscountMessage(

          "This discount code is invalid, does not apply to the current cart, or cannot be combined with another discount.",

          "error"

        );

      }

   else {

  // =========================================
  // SAVE MANUAL COUPON
  // =========================================

  setManualDiscountCode(
    normalizedCode
  );


  setDiscountMessage(
    "",
    ""
  );


  // =========================================
  // REMOVE FREE GIFT WHEN ANOTHER
  // COUPON HAS BEEN APPLIED
  // =========================================

  if (
    normalizedCode
      .trim()
      .toUpperCase() !== "FREEGIFT"
  ) {

    await manageFreeGift(
      latestCart
    );


    // IMPORTANT:
    // Fetch cart again AFTER free gift removal.
    // This gives us the correct subtotal,
    // total_discount and line discounts.
    latestCart =
      await getCart();

  }


  // =========================================
  // CLEAR DISCOUNT INPUT
  // =========================================

  const newInput =
    document.querySelector(
      "#DiscountCode"
    );

  if (newInput) {

    newInput.value = "";

  }

}

    }


    // =========================================
    // UPDATE CART UI
    // =========================================

    await updateFreeShippingClass(
      latestCart,
      true
    );


    await updateCartSubtotal(
      latestCart
    );


    await syncLifetimeWarrantyCheckboxes(
      latestCart
    );


    updateFreeGiftDiscountUI(
      latestCart
    );


    return true;

  }


  catch (error) {

    console.error(
      "Manual discount error:",
      error
    );


    setDiscountMessage(

      error.message ||
      "Discount could not be applied.",

      "error"

    );


    return false;

  }


  finally {

    discountActionRunning =
      false;


    const newInput =
      document.querySelector(
        "#DiscountCode"
      );


    const newButton =
      document.querySelector(
        "#ApplyDiscount"
      );


    if (newInput) {

      newInput.disabled =
        false;

    }


    if (newButton) {

      newButton.disabled =
        false;


      newButton.textContent =
        "Apply Now";

    }

  }

}


document.addEventListener(
  "click",
  function (event) {

    const removeButton =
      event.target.closest(
        '[aria-label="Remove discount FREEGIFT"]'
      );

    if (!removeButton) {
      return;
    }


    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();


    // =========================================
    // CLEAR INPUT + COUPON IMMEDIATELY
    // =========================================

    clearFreeGiftCouponUI();


    // =========================================
    // FIND FREE GIFT PRODUCT
    // =========================================

    if (
      !currentCartSnapshot ||
      !Array.isArray(
        currentCartSnapshot.items
      )
    ) {
      return;
    }


    const freeGiftItem =
      currentCartSnapshot.items.find(
        isFreeGiftItem
      );


    if (!freeGiftItem) {
      return;
    }


    // =========================================
    // REMEMBER CUSTOMER REMOVED FREE GIFT
    // =========================================

    setFreeGiftManuallyRemoved(
      true
    );


    // =========================================
    // REMOVE FREE GIFT PRODUCT
    // =========================================

    removeFreeGiftByCustomer(
      freeGiftItem
    );

  },

  true
);

document.addEventListener(

  "submit",

  function(event) {

    const form =
      event.target.closest(
        ".custom-discount-form"
      );


    if (!form) {
      return;
    }


    event.preventDefault();

    event.stopPropagation();

    event.stopImmediatePropagation();


    const input =
      form.querySelector(
        "#DiscountCode"
      );


    const code =
      input?.value?.trim() || "";


    if (!code) {

      setDiscountMessage(
        "Enter a discount code.",
        "error"
      );


      return;

    }


    updateManualDiscount(
      code
    );

  },

  true

);


// =====================================================
// APPLY DISCOUNT BUTTON
// =====================================================

document.addEventListener(

  "click",

  function(event) {

    const applyButton =
      event.target.closest(
        "#ApplyDiscount"
      );


    if (!applyButton) {
      return;
    }


    event.preventDefault();

    event.stopPropagation();

    event.stopImmediatePropagation();


    const input =
      document.querySelector(
        "#DiscountCode"
      );


    const code =
      input?.value?.trim() || "";


    if (!code) {

      setDiscountMessage(
        "Enter a discount code.",
        "error"
      );


      return;

    }


    updateManualDiscount(
      code
    );

  },

  true

);


// =====================================================
// REMOVE MANUAL DISCOUNT
// =====================================================

document.addEventListener(

  "click",

  function(event) {

    const removeButton =
      event.target.closest(
        "[data-remove-manual-discount]"
      );


    if (!removeButton) {
      return;
    }


    event.preventDefault();

    event.stopPropagation();

    event.stopImmediatePropagation();


    updateManualDiscount(
      ""
    );

  },

  true

);

async function updateFreeShippingClass(
  cartData = null,
  noAnimation = false
) {

  try {

    const cart =
      cartData ||
      await getCart();


    const cartTotal =
      cart.total_price;


    const eligibleTotal =
      getFreeGiftEligibleSubtotal(
        cart
      );


    // =================================================
    // FREE SHIPPING
    // =================================================

    document
      .querySelectorAll(
        ".freeshippingbar"
      )
      .forEach(
        bar => {

        bar.classList.toggle(
  "freeshippinghit",
  eligibleTotal >=
    FREE_SHIPPING_THRESHOLD
);

        }
      );


    // =================================================
    // CALCULATE PROGRESS
    // =================================================

// =====================================================
// UPDATE OFFER TEXT
// =====================================================

updateOfferText(
  eligibleTotal,
  cart
);


// =====================================================
// CALCULATE PROGRESS
// =====================================================

let progressbarWidth = 0;


if (
  eligibleTotal >=
  FREE_GIFT_THRESHOLD
) {

  progressbarWidth = 100;

}

else if (
  eligibleTotal >=
  FREE_SHIPPING_THRESHOLD
) {

  progressbarWidth =
    (
      (
        eligibleTotal -
        FREE_SHIPPING_THRESHOLD
      )
      /
      (
        FREE_GIFT_THRESHOLD -
        FREE_SHIPPING_THRESHOLD
      )
    )
    * 100;

}


// =================================================
// PROGRESS BAR
// =================================================

    document
      .querySelectorAll(
        ".offer_sagment"
      )
      .forEach(
        offer => {


          offer.classList.toggle(

            "offerhit",

            eligibleTotal >=
              FREE_SHIPPING_THRESHOLD

          );


          /*
           * FAST + SMOOTH
           *
           * The third "important" parameter
           * overrides your existing:
           *
           * transition: width .8s !important;
           */
        offer.style.setProperty(
  "transition",
  noAnimation
    ? "none"
    : "width 0.3s ease-out",
  "important"
);


          if (
            eligibleTotal >=
            FREE_GIFT_THRESHOLD
          ) {

            offer.classList.add(
              "offer-complete"
            );


            offer.style.width =
              "100%";

          }

          else {

            offer.classList.remove(
              "offer-complete"
            );


            offer.style.width =
              `${progressbarWidth.toFixed(2)}%`;

          }
if (noAnimation) {

  // Force the browser to immediately apply
  // the existing progress state
  void offer.offsetWidth;

  requestAnimationFrame(() => {

    offer.style.setProperty(
      "transition",
      "width 0.3s ease-out",
      "important"
    );

  });

}

        }
      );


    // =================================================
    // FREE GIFT ICON
    // =================================================

    const freeGiftIcon =
      document.querySelector(
        ".offericonhit"
      );


    const freeGiftReached =

      eligibleTotal >=
      FREE_GIFT_THRESHOLD;


    if (freeGiftIcon) {

      freeGiftIcon.classList.toggle(

        "freegifthit",

        freeGiftReached

      );

    }


    // =================================================
    // CONFETTI
    // =================================================

    if (!freeGiftReached) {

  freeGiftCelebrated = false;

}


    if (!freeGiftReached) {

      freeGiftCelebrated =
        false;

    }


  }

  catch (error) {

    console.error(
      "Progress update error:",
      error
    );

  }

}


// =====================================================
// UPDATE SUBTOTAL
// =====================================================

async function updateCartSubtotal(
  cartData = null
) {

  try {

    const cart =
      cartData ||
      await getCart();


    const formattedTotal =
      new Intl.NumberFormat(
        "en-US",
        {

          style:
            "currency",

          currency:
            "USD"

        }
      ).format(
        cart.total_price / 100
      );


    document
      .querySelectorAll(
        ".totals__subtotal-value"
      )
      .forEach(
        subtotal => {

          subtotal.textContent =
            formattedTotal;
            

        }
      );


  }

  catch (error) {

    console.error(
      "Subtotal update error:",
      error
    );

  }

}


// =====================================================
// WARRANTY VISIBILITY
// =====================================================

function setWarrantyVisibility(
  checkbox,
  visible
) {

  const warrantyContainer =
    checkbox.closest(
      ".lifetime-warranty"
    );


  if (warrantyContainer) {

    warrantyContainer.style.display =
      visible
        ? ""
        : "none";

  }

  else {

    checkbox.style.display =
      visible
        ? ""
        : "none";

  }

}


// =====================================================
// PRESERVE PROGRESS BAR DURING WARRANTY UPDATE
// =====================================================

function captureProgressBarState() {

  return Array.from(
    document.querySelectorAll(
      ".offer_sagment"
    )
  ).map(bar => {

    let width =
      bar.style.width;


    // Fallback if width is not inline
    if (!width) {

      const parent =
        bar.parentElement;

      if (parent) {

        const parentWidth =
          parent.getBoundingClientRect().width;

        const barWidth =
          bar.getBoundingClientRect().width;


        if (parentWidth > 0) {

          width =
            `${(
              barWidth /
              parentWidth
            ) * 100}%`;

        }

      }

    }


    return {
      width: width || "0%",
      offerHit:
        bar.classList.contains(
          "offerhit"
        ),
      complete:
        bar.classList.contains(
          "offer-complete"
        )
    };

  });

}


// =====================================================
// RESTORE PROGRESS WITHOUT ANIMATION
// =====================================================

function restoreProgressBarState(
  states
) {

  const bars =
    document.querySelectorAll(
      ".offer_sagment"
    );


  bars.forEach(
    (bar, index) => {

      const state =
        states[index];


      if (!state) {
        return;
      }


      // Stop animation temporarily
      bar.style.setProperty(
        "transition",
        "none",
        "important"
      );


      // Restore exact previous width
      bar.style.width =
        state.width;


      bar.classList.toggle(
        "offerhit",
        state.offerHit
      );


      bar.classList.toggle(
        "offer-complete",
        state.complete
      );


      // Force browser to apply width
      void bar.offsetWidth;


      // Restore smooth animation
      requestAnimationFrame(
        () => {

          bar.style.setProperty(
            "transition",
            "width 0.3s ease-out",
            "important"
          );

        }
      );

    }
  );

}


// =====================================================
// RENDER CART BUT KEEP PROGRESS BAR FIXED
// =====================================================

function renderCartPreserveProgress(
  data,
  progressState
) {

  renderCartSections(
    data
  );


  restoreProgressBarState(
    progressState
  );

}


// =====================================================
// SYNC WARRANTY CHECKBOXES
// =====================================================

async function syncLifetimeWarrantyCheckboxes(
  cartData = null
) {

  try {

    const cart =
      cartData ||
      await getCart();


    document
      .querySelectorAll(
        "[data-lifetime-warranty]"
      )
      .forEach(
        checkbox => {


          const parentLineKey =
            checkbox.dataset
              .parentLineKey;


          if (!parentLineKey) {

            return;

          }


          const parentItem =
            cart.items.find(

              item =>
                item.key ===
                parentLineKey

            );


          // =================================================
          // FREE GIFT
          // =================================================

          if (

            parentItem &&

            isFreeGiftItem(
              parentItem
            )

          ) {

            checkbox.checked =
              false;


            setWarrantyVisibility(
              checkbox,
              false
            );


            return;

          }


          // =================================================
          // NORMAL PRODUCT
          // =================================================

          setWarrantyVisibility(
            checkbox,
            true
          );


          checkbox.checked =
            Boolean(

              findWarrantyForParent(
                cart,
                parentLineKey
              )

            );


        }
      );


  }

  catch (error) {

    console.error(
      "Warranty checkbox sync error:",
      error
    );

  }

}


// =====================================================
// WARRANTY QUANTITY SYNC
//
// Parent qty 1 = Warranty qty 1
// Parent qty 2 = Warranty qty 2
//
// Removes:
// Duplicate warranties
// Orphan warranties
// Free gift warranties
//
// Optimized:
// Uses one cart snapshot instead of fetching
// cart again for every warranty item.
// =====================================================

async function syncWarrantyQuantities(
  cartData = null
) {

  if (
    warrantySyncRunning
  ) {

    return false;

  }


  warrantySyncRunning =
    true;


  let changed =
    false;


  let lastResponse =
    null;


  try {

    const cart =
      cartData ||
      await getCart();


    const warrantyItems =
      cart.items.filter(
        isWarrantyItem
      );


    const seenParents =
      new Set();


    for (
      const warrantyItem
      of warrantyItems
    ) {


      const parentKey =
        getWarrantyParentKey(
          warrantyItem
        );


      // =================================================
      // ORPHAN WARRANTY
      // =================================================

      if (!parentKey) {

        lastResponse =
          await changeCartLine(

            warrantyItem.key,

            0,

            false

          );


        changed = true;

        continue;

      }


      const parentItem =
        cart.items.find(

          item =>
            item.key ===
            parentKey

        );


      // =================================================
      // PARENT REMOVED
      // =================================================

      if (!parentItem) {

        lastResponse =
          await changeCartLine(

            warrantyItem.key,

            0,

            false

          );


        changed = true;

        continue;

      }


      // =================================================
      // FREE GIFT CANNOT HAVE WARRANTY
      // =================================================

      if (
        isFreeGiftItem(
          parentItem
        )
      ) {

        lastResponse =
          await changeCartLine(

            warrantyItem.key,

            0,

            false

          );


        changed = true;

        continue;

      }


      // =================================================
      // DUPLICATE WARRANTY
      // =================================================

      if (
        seenParents.has(
          parentKey
        )
      ) {

        lastResponse =
          await changeCartLine(

            warrantyItem.key,

            0,

            false

          );


        changed = true;

        continue;

      }


      seenParents.add(
        parentKey
      );


      // =================================================
      // WARRANTY QUANTITY = PARENT QUANTITY
      // =================================================

      const correctQuantity =
        Number(
          parentItem.quantity
        ) || 1;


      if (

        Number(
          warrantyItem.quantity
        )

        !==

        correctQuantity

      ) {

        lastResponse =
          await changeCartLine(

            warrantyItem.key,

            correctQuantity,

            false

          );


        changed = true;

      }


    }


    if (
      changed &&
      lastResponse
    ) {

      renderCartSections(
        lastResponse
      );

    }


    return changed;


  }

  catch (error) {

    console.error(
      "Warranty quantity sync error:",
      error
    );


    return false;

  }

  finally {

    warrantySyncRunning =
      false;

  }

}


// =====================================================
// LIFETIME WARRANTY CHECKBOX
//
// Capture phase prevents Shopify cart quantity
// code from handling the warranty checkbox.
// =====================================================

document.addEventListener(

  "change",

  function (event) {


    const checkbox =
      event.target.closest(
        "[data-lifetime-warranty]"
      );


    if (!checkbox) {

      return;

    }

event.stopPropagation();
    event.stopImmediatePropagation()


    handleLifetimeWarrantyChange(
      checkbox
    );


  },

  true

);


// =====================================================
// HANDLE WARRANTY CHANGE
// =====================================================

async function handleLifetimeWarrantyChange(
  checkbox
) {

  if (
    warrantyActionRunning
  ) {
    return;
  }


  const parentLineKey =
    checkbox.dataset
      .parentLineKey;


  if (!parentLineKey) {

    console.error(
      "Warranty parent line key missing"
    );

    return;

  }


  const wantedCheckedState =
    checkbox.checked;


  // Keep progress bar exactly where it is
  const progressState =
    captureProgressBarState();


  // =========================================
  // PRESERVE CURRENT TICKER TEXT
  // =========================================

  const currentOfferText =
    document.querySelector(
      ".offer_applied_text_container"
    );


  offerTextLocked = true;


  lockedOfferTextValue =
    currentOfferText
      ?.textContent
      ?.trim()
    ||
    "";


  applyLockedOfferText();


  warrantyActionRunning =
    true;


  checkbox.disabled =
    true;


  try {

    // =================================================
    // CURRENT CART
    // =================================================

    const cart =
      await getCart();


    // =================================================
    // PARENT PRODUCT
    // =================================================

    const parentItem =
      cart.items.find(

        item =>
          item.key ===
          parentLineKey

      );


    if (!parentItem) {

      throw new Error(
        "Warranty parent product not found"
      );

    }


    // =================================================
    // FREE GIFT
    // NEVER ADD WARRANTY
    // =================================================

    if (
      isFreeGiftItem(
        parentItem
      )
    ) {

      checkbox.checked =
        false;


      setWarrantyVisibility(
        checkbox,
        false
      );


      return;

    }


    const warrantyItem =
      findWarrantyForParent(
        cart,
        parentLineKey
      );


    // =================================================
    // CHECKED → ADD WARRANTY
    // =================================================

    if (
      wantedCheckedState &&
      !warrantyItem
    ) {

      const root =
        window.Shopify
          ?.routes
          ?.root || "/";


      const response =
        await fetch(

          root + "cart/add.js",

          {

            method:
              "POST",


            headers: {

              "Content-Type":
                "application/json",

              Accept:
                "application/json"

            },


            body: JSON.stringify({

              items: [

                {

                  id:
                    WARRANTY_VARIANT_ID,


                  quantity:
                    parentItem.quantity,


                  parent_line_key:
                    parentLineKey,


                  properties: {

                    "_Lifetime Warranty":
                      "Yes",

                    "_Warranty Parent Key":
                      parentLineKey

                  }

                }

              ],


              sections:
                CART_SECTIONS,


              sections_url:
                window.location.pathname

            })

          }

        );


      const data =
        await response.json();


      if (!response.ok) {

        console.error(
          "Warranty API response:",
          data
        );


        throw new Error(

          data.description ||

          data.message ||

          "Lifetime Warranty could not be added"

        );

      }


      renderCartPreserveProgress(
        data,
        progressState
      );

    }


    // =================================================
    // UNCHECKED → REMOVE WARRANTY
    // =================================================

    else if (
      !wantedCheckedState &&
      warrantyItem
    ) {

      const data =
        await changeCartLine(
          warrantyItem.key,
          0,
          false
        );


      renderCartPreserveProgress(
        data,
        progressState
      );

    }

  }


  catch (error) {

    console.error(
      "Lifetime warranty error:",
      error
    );


    checkbox.checked =
      !wantedCheckedState;

  }


  finally {

    warrantyActionRunning =
      false;


    // -----------------------------------------
    // GET LATEST CART
    // -----------------------------------------

    let latestCart =
      await getCart();


    // -----------------------------------------
    // SYNC WARRANTY QUANTITY
    // -----------------------------------------

    const warrantyChanged =
      await syncWarrantyQuantities(
        latestCart
      );


    if (warrantyChanged) {

      latestCart =
        await getCart();

    }


    // -----------------------------------------
    // UPDATE CART SUBTOTAL
    // Warranty DOES count here
    // -----------------------------------------

    await updateCartSubtotal(
      latestCart
    );


    // -----------------------------------------
    // SYNC WARRANTY CHECKBOXES
    // -----------------------------------------

    await syncLifetimeWarrantyCheckboxes(
      latestCart
    );


    // -----------------------------------------
    // UPDATE FREE GIFT / DISCOUNT UI
    // -----------------------------------------

    updateFreeGiftDiscountUI(
      latestCart
    );


    // -----------------------------------------
    // RESTORE PROGRESS BAR
    // -----------------------------------------

    restoreProgressBarState(
      progressState
    );


    // =========================================
    // UNLOCK OFFER TICKER
    // =========================================

    offerTextLocked =
      false;


    lockedOfferTextValue =
      "";


    // =========================================
    // RECALCULATE FINAL TICKER
    //
    // Examples:
    // LABORDAY Applied
    // Free Gift Applied
    // Free Shipping Applied
    // =========================================

    await updateFreeShippingClass(
      latestCart,
      true
    );


    // -----------------------------------------
    // ENABLE NEW CHECKBOX AFTER RENDER
    // -----------------------------------------

    const newCheckbox =
      document.querySelector(
        `[data-lifetime-warranty][data-parent-line-key="${CSS.escape(parentLineKey)}"]`
      );


    if (newCheckbox) {

      newCheckbox.disabled =
        false;

    }

    else {

      checkbox.disabled =
        false;

    }

  }

}


// =====================================================
// ADD FREE GIFT
// =====================================================

async function addFreeGift() {

  const response =
    await fetch(
      "/cart/add.js",
      {

        method: "POST",

        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },

        body: JSON.stringify({

          items: [
            {
              id: FREE_GIFT_VARIANT_ID,
              quantity: 1,

              properties: {
                "_Free Gift": "Yes"
              }
            }
          ],

          sections: CART_SECTIONS,

          sections_url:
            window.location.pathname

        })

      }
    );


  const data =
    await response.json();


  if (!response.ok) {

    throw new Error(
      data.description ||
      data.message ||
      "Free gift could not be added"
    );

  }


  // Render gift immediately
  renderCartSections(data);
  // =========================================
// FREE GIFT SUCCESSFULLY ADDED
// =========================================

if (!freeGiftCelebrated) {

  freeGiftCelebrated = true;

  requestAnimationFrame(() => {

    showCelebration();

  });

}


  // Celebration can happen slightly later
  if (!freeGiftCelebrated) {

    freeGiftCelebrated = true;

    setTimeout(
      () => {

        showCelebration();
        

      },
      500
    );

  }


  return data;
}


// =====================================================
// MANAGE FREE GIFT
//
// Optimized to reuse existing cart data.
// =====================================================

async function manageFreeGift(
  cartData = null
) {

  if (freeGiftActionRunning) {
    return false;
  }

  freeGiftActionRunning = true;

  try {

    const cart =
      cartData ||
      await getCart();


    const eligibleSubtotal =
      getFreeGiftEligibleSubtotal(cart);


    const freeGiftItems =
      cart.items.filter(
        isFreeGiftItem
      );


    const freeGiftItem =
      freeGiftItems[0] || null;


    // =================================================
    // CHECK FOR ANY MANUAL COUPON
    // FREEGIFT DOES NOT COUNT AS A MANUAL COUPON
    // =================================================

    const activeManualCoupon =
      getActiveManualCouponCode(cart);


    // =================================================
    // MANUAL COUPON APPLIED
    // REMOVE ALL FREE GIFT PRODUCTS
    // =================================================

    if (activeManualCoupon) {

      if (!freeGiftItems.length) {
        return false;
      }


      let lastResponse = null;


      for (const gift of freeGiftItems) {

        // Remove any warranty attached to gift first
        const giftWarrantyItems =
          cart.items.filter(
            item =>
              isWarrantyItem(item) &&
              getWarrantyParentKey(item) === gift.key
          );


        for (const warrantyItem of giftWarrantyItems) {

          lastResponse =
            await changeCartLine(
              warrantyItem.key,
              0,
              false
            );

        }


        // Remove free gift itself
        lastResponse =
          await changeCartLine(
            gift.key,
            0,
            false
          );

      }

// Allow celebration again if gift gets added back later
freeGiftCelebrated = false;
      // IMPORTANT:
      // Customer did NOT manually remove the gift.
      // It was removed because another coupon is active.
      setFreeGiftManuallyRemoved(false);


      if (lastResponse) {

        renderCartSections(
          lastResponse
        );

      }


      return true;

    }


    // =================================================
    // RESET CUSTOMER OPT-OUT
    // WHEN CART DROPS BELOW $1500
    // =================================================

    if (
      eligibleSubtotal <
      FREE_GIFT_THRESHOLD
    ) {

      setFreeGiftManuallyRemoved(
        false
      );

    }


    // =================================================
    // $1500+
    // ADD FREE GIFT
    //
    // ONLY WHEN NO OTHER MANUAL COUPON EXISTS
    // =================================================

    if (
      eligibleSubtotal >=
        FREE_GIFT_THRESHOLD
      &&
      !freeGiftItem
      &&
      !freeGiftManuallyRemoved
    ) {

      await addFreeGift();

      return true;

    }


    // =================================================
    // BELOW $1500
    // REMOVE FREE GIFT
    // =================================================

    if (
      eligibleSubtotal <
        FREE_GIFT_THRESHOLD
      &&
      freeGiftItems.length
    ) {

      let lastResponse =
        null;


      for (const gift of freeGiftItems) {


        const giftWarrantyItems =
          cart.items.filter(

            item =>

              isWarrantyItem(item)

              &&

              getWarrantyParentKey(item) ===
                gift.key

          );


        // Remove warranty first
        for (
          const warrantyItem
          of giftWarrantyItems
        ) {

          lastResponse =
            await changeCartLine(
              warrantyItem.key,
              0,
              false
            );

        }


        // Remove free gift
        lastResponse =
          await changeCartLine(
            gift.key,
            0,
            false
          );

      }


      if (lastResponse) {

        renderCartSections(
          lastResponse
        );

      }


      return true;

    }


    if (!freeGiftItem) {
      return false;
    }


    // =================================================
    // MULTIPLE GIFTS
    // KEEP ONE ONLY
    // =================================================

    if (
      freeGiftItems.length > 1
    ) {

      let lastResponse =
        null;


      for (
        const extraGift
        of freeGiftItems.slice(1)
      ) {

        lastResponse =
          await changeCartLine(
            extraGift.key,
            0,
            false
          );

      }


      if (lastResponse) {

        renderCartSections(
          lastResponse
        );

      }


      return true;

    }


    // =================================================
    // FREE GIFT QUANTITY ALWAYS 1
    // =================================================

    if (
      Number(
        freeGiftItem.quantity
      ) !== 1
    ) {

      await changeCartLine(
        freeGiftItem.key,
        1,
        true
      );


      return true;

    }


    // =================================================
    // REMOVE WARRANTY FROM FREE GIFT
    // =================================================

    const giftWarrantyItems =
      cart.items.filter(

        item =>

          isWarrantyItem(item)

          &&

          getWarrantyParentKey(item) ===
            freeGiftItem.key

      );


    if (
      giftWarrantyItems.length
    ) {

      let lastResponse =
        null;


      for (
        const warrantyItem
        of giftWarrantyItems
      ) {

        lastResponse =
          await changeCartLine(
            warrantyItem.key,
            0,
            false
          );

      }


      if (lastResponse) {

        renderCartSections(
          lastResponse
        );

      }


      return true;

    }


    return false;

  }

  catch (error) {

    console.error(
      "Free gift error:",
      error
    );

    return false;

  }

  finally {

    freeGiftActionRunning =
      false;

  }

}

// =====================================================
// CUSTOMER CAN REMOVE FREE GIFT
// =====================================================

function getCartDrawerItemFromRemoveControl(
  removeControl
) {

  if (
    !removeControl ||
    !currentCartSnapshot ||
    !Array.isArray(
      currentCartSnapshot.items
    )
  ) {

    return null;

  }


  let index =
    Number(
      removeControl.dataset?.index || 0
    );


  // Try nearest data-index
  if (!index) {

    const indexedParent =
      removeControl.closest(
        "[data-index]"
      );


    index =
      Number(
        indexedParent?.dataset?.index || 0
      );

  }


  // Dawn normally uses IDs like:
  // CartDrawer-Remove-1
  if (!index) {

    const id =
      removeControl.id || "";


    const match =
      id.match(
        /Remove-(\d+)/i
      );


    if (match) {

      index =
        Number(
          match[1]
        );

    }

  }


  if (!index) {
    return null;
  }


  return (

    currentCartSnapshot
      .items[
        index - 1
      ]

    ||

    null

  );

}



// =====================================================
// REMOVE FREE GIFT MANUALLY
// =====================================================

async function removeFreeGiftByCustomer(
  freeGiftItem
) {

  if (

    !freeGiftItem ||

    !isFreeGiftItem(
      freeGiftItem
    ) ||

    freeGiftActionRunning

  ) {

    return;

  }


  // Remember customer intentionally removed it
  setFreeGiftManuallyRemoved(
    true
  );


  freeGiftActionRunning =
    true;


  try {

    const data =
      await changeCartLine(

        freeGiftItem.key,

        0,

        true

      );


    const latestCart =
      await getCart();


    await updateFreeShippingClass(
      latestCart,
      true
    );


    await updateCartSubtotal(
      latestCart
    );


    await syncLifetimeWarrantyCheckboxes(
      latestCart
    );


    updateFreeGiftDiscountUI(
      latestCart
    );


    return data;

  }


  catch (error) {

    console.error(
      "Free gift remove error:",
      error
    );


    // Removal failed, allow gift again
    setFreeGiftManuallyRemoved(
      false
    );

  }


  finally {

    freeGiftActionRunning =
      false;

  }

}



// =====================================================
// INTERCEPT FREE GIFT REMOVE CLICK
// =====================================================

document.addEventListener(

  "click",

  function (event) {


    const removeControl =
      event.target.closest(

        "cart-remove-button, [id^='CartDrawer-Remove-']"

      );


    if (!removeControl) {
      return;
    }


    const cartItem =
      getCartDrawerItemFromRemoveControl(
        removeControl
      );


    // Normal product:
    // let Shopify handle removal normally.
    if (

      !cartItem ||

      !isFreeGiftItem(
        cartItem
      )

    ) {

      return;

    }


    // Free gift:
    // use our controlled removal.
    event.preventDefault();

    event.stopPropagation();

    event.stopImmediatePropagation();


    removeFreeGiftByCustomer(
      cartItem
    );

  },

  true

);


// =====================================================
// MASTER CART SYNC
//
// SPEED IMPROVEMENTS:
//
// 1. Fetch cart once initially.
// 2. Progress updates immediately.
// 3. Reuse cart data.
// 4. Only fetch again when gift/warranty actually changed.
// =====================================================

// =====================================================
// MASTER CART SYNC
// =====================================================

async function runCartSync() {

 if (
  cartSyncRunning ||
  warrantyActionRunning ||
  warrantySyncRunning ||
  freeGiftActionRunning ||
  discountActionRunning
) {

  return;

}


  cartSyncRunning = true;


  try {

    // -----------------------------------------
    // 1. GET CURRENT CART
    // -----------------------------------------

    let cart =
      await getCart();


    // -----------------------------------------
    // 2. FREE GIFT FIRST
    // -----------------------------------------

    const giftChanged =
      await manageFreeGift(
        cart
      );


    if (giftChanged) {

      cart =
        await getCart();

    }


    // -----------------------------------------
    // 3. UPDATE UI USING MAIN PRODUCT VALUE
    //
    // Warranty + free gift are excluded by
    // getFreeGiftEligibleSubtotal()
    // -----------------------------------------

    await Promise.all([

      updateFreeShippingClass(
        cart
      ),

      updateCartSubtotal(
        cart
      )

    ]);


    // -----------------------------------------
    // 4. SYNC WARRANTY QUANTITY
    //
    // Example:
    // Main product qty 3
    // Warranty qty becomes 3
    // -----------------------------------------

    const warrantyChanged =
      await syncWarrantyQuantities(
        cart
      );


    // =================================================
    // IMPORTANT FIX
    //
    // Warranty sync re-renders cart drawer.
    // Therefore progress/text MUST be restored again
    // using MAIN PRODUCT value only.
    // =================================================

    if (warrantyChanged) {

      cart =
        await getCart();


      // -----------------------------------------
      // Recalculate progress after warranty render
      // -----------------------------------------

      await updateFreeShippingClass(
        cart
      );


      // Warranty price DOES count in cart subtotal
      await updateCartSubtotal(
        cart
      );


      // Cart drawer was re-rendered,
      // restore FREEGIFT discount UI
      updateFreeGiftDiscountUI(
        cart
      );

    }


    // -----------------------------------------
    // 5. WARRANTY CHECKBOX STATE
    // -----------------------------------------

    await syncLifetimeWarrantyCheckboxes(
      cart
    );


    // -----------------------------------------
    // 6. FREE GIFT DISCOUNT UI
    // -----------------------------------------

    updateFreeGiftDiscountUI(
      cart
    );


  }

  catch (error) {

    console.error(
      "Cart sync error:",
      error
    );

  }

  finally {

    cartSyncRunning =
      false;

  }

}


// =====================================================
// FAST DEBOUNCE
//
// OLD: 500ms
// NEW: 60ms
// =====================================================

function scheduleCartUpdates() {

  clearTimeout(
    cartUpdateTimer
  );


  cartUpdateTimer =
    setTimeout(

      () => {

        runCartSync();

      },

      10

    );

}


// =====================================================
// PAGE LOAD
// =====================================================

document.addEventListener(

  "DOMContentLoaded",

  () => {

    runCartSync();

  }

);


// =====================================================
// WATCH SHOPIFY AJAX CART CHANGES
// =====================================================

(function interceptCartFetch() {

  const originalFetch =
    window.fetch;


  window.fetch =
    function (...args) {


      return originalFetch

        .apply(
          this,
          args
        )

        .then(
          response => {


            const url =

              typeof args[0] ===
                "string"

                ?

                args[0]

                :

                args[0]?.url ||
                "";


            const isCartChange =

              url.includes(
                "/cart/add"
              )

              ||

              url.includes(
                "/cart/change"
              )

              ||

              url.includes(
                "/cart/update"
              )

              ||

              url.includes(
                "/cart/clear"
              );


           if (

  isCartChange &&

  !cartSyncRunning &&

  !warrantyActionRunning &&

  !warrantySyncRunning &&

  !freeGiftActionRunning &&

  !discountActionRunning

){

              scheduleCartUpdates();

            }


            return response;

          }
        );


    };

})();

// for chat icon

function updateHelpActivator() {
  const shouldHide =
    document.body.classList.contains("overflow-hidden");

  document.querySelectorAll("*").forEach((element) => {
    if (!element.shadowRoot) return;

    const activator = element.shadowRoot.querySelector(
      ".activator-nudge.activator-nudge--right"
    );

    if (activator) {
      activator.style.display = shouldHide
        ? "none"
        : "";
    }
  });
}

const observer = new MutationObserver(updateHelpActivator);

observer.observe(document.body, {
  attributes: true,
  attributeFilter: ["class"]
});

updateHelpActivator();


